import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';

class ForgotPasswordEmail extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  };

  render() {
    const buttonStyle = {
      margin: 0,
      fontFamily: 'Arial',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#0667B3',
      backgroundColor: '#0667B3',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const textStyle = {
      color: '#404040',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px'
    };
    const { content: { token, email, name, logo } } = this.props;
    let verificationURL = url + `/password/verification?token=${token}&email=${email}`;

    return (
      <Layout>
        <Header color="#0667B3" backgroundColor="#F7F7F7" logo={logo} />
        <Body textStyle={textStyle}>
          <div>
            Hallo {name},
          </div>
          <EmptySpace height={20} />
          <div>
            Wir haben eine Anfrage zur Rücksetzung Ihres Passwortes erhalten.
          </div>
          <EmptySpace height={20} />
          <div>
            Falls Sie diese Anfrage nicht gestellt haben, ignorieren Sie einfach diese Nachricht. Ansonsten können Sie Ihr Passwort zurücksetzen indem Sie auf folgenden Link klicken:
          </div>
          <EmptySpace height={40} />
          <div>
            <a style={buttonStyle} href={verificationURL}>Passwort zurücksetzen</a>
          </div>
          <EmptySpace height={30} />
          <div>
            Vielen Dank, <br />
            Ihr {sitename} Team
          </div>
        </Body>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ForgotPasswordEmail;
